import { useMemo } from 'react';

import FormHeader from 'components/global/FormHeader';
import { HeaderContainerFormHeader } from 'components/global/styled/FormHeader.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, WMS_MODULE } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';
import PATHS, { mergePaths } from 'utils/paths';

import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

const OrderBasedTransaction = () => {
	const defaultSort = useMemo(() => [{ id: 'OrderDate', desc: true }], []);

	const columns = useMemo(
		() => [
			{ Header: 'ID', accessor: 'ID', filterType: FilterType.number, show: false, width: 10 },
			{
				Header: 'orderDate',
				accessor: 'OrderDate',
				renderCell: ListComponents.DATETIME,
				filterType: FilterType.date,
				width: 10
			},
			{ Header: 'orderID', accessor: 'OrderID', filterType: FilterType.string, width: 30 },
			{
				Header: 'warehouseName',
				accessor: 'WarehouseName',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.WAREHOUSES,
				width: 100
			},
			{
				Header: 'branchName',
				accessor: 'BranchName',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.BRANCHES,
				width: 100
			},
			{ Header: 'sku', accessor: 'SKU', filterType: FilterType.string, width: 30 },
			{ Header: 'quantity', accessor: 'OrderQuantity', filterType: FilterType.float, width: 10 },
			{
				Header: 'inventoryAvailableTransactions',
				accessor: 'InventoryAvailableTransactions',
				filterType: FilterType.float,
				width: 30
			},
			{
				Header: 'inventoryOnHandTransactions',
				accessor: 'InventoryOnHandTransactions',
				filterType: FilterType.float,
				width: 30
			},
			{
				Header: 'binInventoryTransactions',
				accessor: 'BinInventoryTransactions',
				filterType: FilterType.float,
				width: 30
			},
			{
				Header: 'packingStatus',
				accessor: 'PackingStatus',
				enumName: ENUMS.PACKING_STATUS,
				filterType: FilterType.enumMulti,
				width: 30
			},
			{
				Header: 'inventoryStatus',
				accessor: 'InventoryStatus',
				enumName: ENUMS.INVENTORY_ORDER_STATUS,
				filterType: FilterType.enumMulti,
				width: 30
			},
			{
				Header: 'status',
				accessor: 'Status',
				enumName: ENUMS.ALL_STATUSES,
				filterType: FilterType.enumMulti,
				width: 30
			}
		],
		[]
	);

	return (
		<div>
			<HeaderContainerFormHeader>
				<FormHeader
					lightTitle="reports"
					boldTitle="orderBasedTransactionReports"
					icon={faArrowLeft}
					backUrl={mergePaths(PATHS.REPORTS, PATHS.OTO_PACK_REPORTS)}
				/>
			</HeaderContainerFormHeader>

			<DynamicList
				id={DYNAMICLISTS.ORDER_BASED_TRANSACTION_REPORTS}
				defaultSort={defaultSort}
				columns={columns}
				fetchUrl={WMS_MODULE.ORDER_BASED_TRANSACTIONS_LIST}
				exportName="orderBasedTransactionReports"
			/>
		</div>
	);
};

export default OrderBasedTransaction;
